module.exports = __webpack_public_path__ + "static/media/ask-question-vote.e98b5525.png";